import { cn } from '@/service/utils/cn';

type TFormDividerProps = {
    className?: string;
};

export const FormDivider = ({ className }: TFormDividerProps) => (
    <div
        className={cn(
            'h-0 w-full max-w-full border-[0.5px] border-gray-4 dark:border-dark-1',
            className
        )}
    />
);
